import {isNullOrUndefined} from "../../../services/Validator";

export default function NeoFlashLinearProgressBar({progression, total}) {
    // Used through the app to display a progression

    // BUILD
    return(
        <div className="w-full border-primaryDark3 shadow-[inset_0px_0px_0px_1px_rgba(22,147,227,1)] rounded-full h-[13px]">
            <div className="bg-gradient-to-t from-primaryDark3 to-primaryLight1 h-[13px] rounded-full"
                 style={{width: computeProgressBarWidth(progression, total)}}>
            </div>
        </div>
    );

    // METHODS
    // ---- UI : Compute progress bar width
    function computeProgressBarWidth(progression, total){
        if (isNullOrUndefined(progression) || isNullOrUndefined(total) || typeof progression !== "number" || typeof total !== "number" || !Number.isInteger(progression) || !Number.isInteger(total) || total <= 0) {
            return '0%'
        } else {
            if (progression >= 0 && progression <= total) {
                return `${Math.round(100*progression/total)}%`
            } else if (progression >= 0 && progression > total) {
                return '100%'
            } else {
                return '0%'
            }
        }
    }
}